import { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from '@chakra-ui/react';
import { omitComponentProps } from '../utils/omitComponentProps';
import { primaryProps } from '../utils/primaryProps';

export const Text1: FC<any> = styled(omitComponentProps(Text, ['primary']))`
  ${primaryProps};
`;
